import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Headlines from "./sections/Headlines";
import Reports from "./sections/Reports";
import Mission from "./sections/Mission";
import Spotlight from "./sections/Spotlight";
import Impact from "./sections/Impact";
import Conversation from "./sections/Conversation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Headlines />
      <Reports />
      <Mission />
      <Spotlight />
      <Impact />
      <Conversation />
      <Footer />
    </div>;
}